import React, { useState } from "react";
import {
  SwipeableDrawer,
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Field from "../Field/Fi";
import Button from "../Button/Button";
import BottomLoginModalPLP from "./BottomLoginModalPLP";
function BottomContactSellerModal({ open, toggleDrawer }) {
  const [loginModal, setLoginModal] = useState(false);
  const handleLoginModal = (bool) => {
    setLoginModal(bool);
  };
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        sx: {
          minHeight: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <CloseIcon
        onClick={() => toggleDrawer(false)}
        sx={{
          width: "16px",
          height: "16px",
          marginLeft: "16px",
          marginTop: "24px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      />
      <Box
        sx={{
          padding: "24px 16px",
        }}
      >
        <Typography
          variant="h3"
          sx={{ fontSize: "22px", fontWeight: "600", lineHeight: "26px" }}
        >
          Contact seller
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            color: "#616161",
          }}
        >
          Send your message to the seller
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            rowGap: "24px",
            marginTop: "24px",
            width: "100%",
          }}
        >
          <Field
            sx={{
              width: "100%",
            }}
            label="Full Name"
            size="small"
            height="48px"
          />
          <Field
            sx={{
              width: "100%",
            }}
            label="Email Address"
            size="small"
            height="48px"
          />
          <Field
            sx={{
              width: "100%",
            }}
            label="Country"
            size="small"
            height="48px"
            select={true}
            
          />
          <Field
            sx={{
              width: "100%",
            }}
            label="Company Name"
            size="small"
            height="48px"
          />
          <TextField
            multiline
            // onFocus={() => setIsFocused(true)}
            // onBlur={() => setIsFocused(false)}
            // value={msg}
            // onChange={(e) => setMsg(e.target.value)}
            label={
              //   !isFocused &&
              //   msg.length == 0 && (
              <Typography
                variant="body1"
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                lineHeight="24px"
                color="#616161"
              >
                Message
              </Typography>
              //   )
            }
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                padding: "0px",
              },
              "& .MuiOutlinedInput-input": {
                minHeight: "88px",
                color: "black",
                padding: "11px 13px",
              },
            }}
          />
        </Box>
        <Box sx={{ marginTop: "26px" }}>
          <FormGroup
            sx={{ display: "flex", flexFlow: "column", rowGap: "16px" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  //   checked={include}
                  //   onChange={(e) => setInclude(e.target.checked)}
                  sx={{
                    padding: "0px",
                    width: "16px",
                    height: "16px",
                    marginRight: "8px",
                    color: "primary.main",
                    "&.Mui-checked": {
                      color: "primary.main",
                    },
                  }}
                />
              }
              sx={{
                margin: "0px",
                "& .MuiTypography-root": {
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#616161",
                  fontStyle: "normal",
                },
              }}
              label="Include me on exclusive offers, giveaways, and machineryplanet.io news."
            />
            <FormControlLabel
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#616161",
                  fontStyle: "normal",
                },
                margin: "0px",
              }}
              control={
                <Checkbox
                  //   checked={also}
                  //   onChange={(e) => setAlso(e.target.checked)}
                  sx={{
                    padding: "0px",
                    width: "16px",
                    height: "16px",
                    marginRight: "8px",
                    color: "primary.main",
                    "&.Mui-checked": {
                      color: "primary.main",
                    },
                  }}
                />
              }
              label="Also, please sign up and login me on Machinery Planet."
            />
          </FormGroup>
        </Box>
        <Button
          variant="contained"
          size="lg"
          txColor="text.primary"
          bgColor="#F9D548"
          sx={{
            height: "48px",
            width: "100%",
            boxShadow: "none",
            marginTop: "24px",
          }}
          //   onClick={handleClose}
          hoverBg="#F3C04F"
          onClick={() => handleLoginModal(true)}
        >
          Submit Now
        </Button>
      </Box>
      <BottomLoginModalPLP open={loginModal} toggleDrawer={handleLoginModal} />
    </SwipeableDrawer>
  );
}

export default BottomContactSellerModal;
